// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-gG3e","textarea":"styles_textarea__316-k"};